import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {NgClass} from "@angular/common";
import {RouterLink} from "@angular/router";
import {TranslateModule} from "@ngx-translate/core";
import {MainStoreService} from "@cybfed/core/store/main.store.service";
import {cx} from "@cybfed/core/utils/ckassnames";

export type ButtonProps = {
  size: 'small' | 'medium' | 'big' ;
  type : 'primary' | 'secondary' | 'danger' | 'success' ;
  textColor: 'white' | 'primary' | 'black';
};

@Component({
  selector: 'white-label-button',
  templateUrl: './button.component.html',
  standalone: true,
  imports: [
    NgClass,
    RouterLink,
    TranslateModule
  ]
})
export class ButtonComponent implements OnInit, OnChanges{
  @Input() text: string = '';
  @Input() icon: string = '';
  @Input() customClasses: string = '';
  @Input() imgCustomClasses: string = '';
  @Input() disabled: boolean = false;
  @Input() mustTranslate: boolean = true;
  @Input() full: boolean = true;
  @Input() type: ButtonProps['type'] = 'primary';
  @Input() size: ButtonProps['size'] = 'medium';
  @Input() textColor: ButtonProps['textColor'] = 'white';
  @Input() link:string = '';
  @Input() route: any;

  @Output() onClick: EventEmitter<any> = new EventEmitter<any>();

  public classes: string = '';
  private baseClasses = "inline-block text-center border border-solid font-medium focus:outline-none rounded-md cursor-pointer ";

  private sizeClasses: Record<ButtonProps['size'], string> = {
    "small": 'text-sm rounded-md xl:min-w-100 py-2 px-2.5',
    "medium": 'text-base rounded-lg xl:min-w-240 py-3 px-3.5',
    "big": 'text-32 rounded-lg xl:min-w-420 min-w-72 px-6 py-4',

  };

  private colorClasses: Record<ButtonProps['textColor'], string> = {
    white: 'text-button-primary',
    primary: 'text-button-primary',
    black: 'text-light-text',
  };

  private typeClasses: Record<ButtonProps['type'], Record<string, string>> = {
    primary: {
      false: 'bg-primary hover:bg-primary-hover border-primary',
      true: 'bg-primary-disabled border-primary'
    },
    secondary: {
      false: 'font-light hover:bg-secondary-hover border-primary',
      true: 'bg-secondary-disabled border-primary'
    },
    danger: {
      false: 'bg-reject text-normal hover:bg-reject-hover border-reject',
      true: 'bg-reject-disabled'
    },
    success: {
      false: 'bg-success text-black border-success hover:bg-success-hover',
      true: 'bg-success-disabled'
    }
  };

  constructor(public mainStore: MainStoreService) {
  }

  ngOnInit() {
    this.setClasses()
  }

  clickButton() {
    if(!this.disabled) this.onClick.emit();
  }

  setClasses(){
    this.classes = cx(
        this.baseClasses,
        this.sizeClasses[this.size],
        this.colorClasses[this.textColor],
        this.typeClasses[this.type][this.disabled.toString()],
        this.full ? 'w-full' : '',
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['disabled']) {
      this.setClasses()
    }
  }

  // detectBackgroundColor(){
  //   if(this.type === TButtonsTypes.PRIMARY){
  //     return this.mainStore.whiteLabel.styling.colors.primary;
  //   } else if(this.type === TButtonsTypes.SECONDARY){
  //     return this.mainStore.whiteLabel.styling.colors.secondary;
  //   } else {
  //     return this.mainStore.whiteLabel.styling.colors.primary;
  //   }
  // }


  // detectCase(): any {
  //   return {
  //     'text-18 rounded-md xl:min-w-100': this.size === TButtonsSizes.SMALL_REGULAR || this.size === TButtonsSizes.SMALL_FIT_CONTENT,
  //     'text-20 rounded-lg xl:min-w-260': this.size === TButtonsSizes.MEDIUM_REGULAR || this.size === TButtonsSizes.MEDIUM_FIT_CONTENT,
  //     'text-32 rounded-lg xl:min-w-420 min-w-72': this.size === TButtonsSizes.BIG_REGULAR || this.size === TButtonsSizes.BIG_FIT_CONTENT
  //   };
  // }
}
